import { JSX, Show, createEffect, onCleanup } from 'solid-js';

interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	children: JSX.Element;
}

export default function Modal(props: ModalProps) {
	let modalRef: HTMLDivElement | undefined;

	const handleKeyDown = (event: KeyboardEvent) => {
		if (event.key === 'Escape') {
			props.onClose();
		}
	};

	const handleBackdropClick = (event: MouseEvent) => {
		if (event.target === modalRef) {
			props.onClose();
		}
	};

	createEffect(() => {
		if (props.isOpen) {
			document.addEventListener('keydown', handleKeyDown);
			document.body.style.overflow = 'hidden';
		} else {
			document.removeEventListener('keydown', handleKeyDown);
			document.body.style.overflow = 'auto';
		}
	});

	onCleanup(() => {
		document.removeEventListener('keydown', handleKeyDown);
		document.body.style.overflow = 'auto';
	});

	return (
		<Show when={props.isOpen}>
			<div
				ref={modalRef}
				class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-5 backdrop-blur-sm"
				onClick={handleBackdropClick}
			>
				<div class="mx-4 w-full border-2 border-green bg-black bg-opacity-25 p-6 text-green shadow-xl md:mx-12">
					<div class="mt-4">{props.children}</div>
				</div>
			</div>
		</Show>
	);
}
